import { useState } from "react";
import { navItems } from "@/mocks/home";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-8">
          <a href="#top" className="flex items-center gap-3">
            <span className="flex h-10 w-10 flex-col items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-article-line text-xl" />
            </span>
            <span className="leading-none">
              <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
                黑料图文
              </h1>
              <span className="mt-1 block font-label text-[11px] tracking-[0.2em] text-foreground-500">
                DEEP DIVE · 深扒长图
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="cursor-pointer rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <a
              href="#ranking"
              className="hidden cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 xl:flex"
            >
              <i className="ri-fire-line text-base" />
              内幕榜单
            </a>
            <a
              href="#download"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-download-2-line text-base" />
              下载图文客户端
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-b border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="mt-2 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50"
            >
              <i className="ri-download-2-line text-base" />
              下载图文客户端
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}